module.exports = __webpack_public_path__ + "img/feature-upload-email-school.22adf8aa.webp";